'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prepareChildKeys = require('./prepareChildKeys');

var _prepareChildKeys2 = _interopRequireDefault(_prepareChildKeys);

var _getIn = require('unmutable/lib/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (key) {
    return function (parcelData) {
        if (typeof key === "string") {
            return key;
        }

        return (0, _pipeWith2.default)(parcelData, (0, _prepareChildKeys2.default)(), (0, _getIn2.default)(['child', key, 'key']));
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/keyOrIndexToKey.js
// module id = 344
// module chunks = 35783957827783